/**
 * Cart Drawer Debug Tool
 * This script provides additional debugging and fixes for cart drawer functionality
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Cart Drawer Debug Tool initialized');

  // Safety check - ensure cart drawer exists
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) {
    console.error('Cart drawer element not found - cannot apply fixes');
    return;
  }

  // Emergency fix: If the close method doesn't exist, add it
  if (typeof cartDrawer.close !== 'function') {
    console.warn('close() method missing from cart-drawer - applying emergency fix');

    cartDrawer.close = function() {
      console.log('Emergency close() method called');
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

      // Hide the drawer for screen readers
      const drawerElement = this.querySelector('.cart-drawer');
      if (drawerElement) {
        drawerElement.setAttribute('aria-hidden', 'true');
      }
    };

    // Re-attach event listeners to close buttons
    const closeButtons = cartDrawer.querySelectorAll('.drawer__close, .drawer__back-button');
    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        cartDrawer.close();
      });
    });

    // Re-attach event listener to overlay
    const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
    if (overlay) {
      overlay.addEventListener('click', function() {
        cartDrawer.close();
      });
    }

    console.log('Emergency fix applied to cart drawer close functionality');
  }

  // Emergency close button functionality has been removed as it was interfering with checkout buttons

  // Monitor cart drawer visibility (keeping observer for other potential uses)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        // Observer kept for potential future functionality
        // Emergency close button has been removed
      }
    });
  });

  observer.observe(cartDrawer, { attributes: true });

  // Back button functionality removed - now using bottom Continue Shopping button only
  console.log('Back button in header disabled - using bottom Continue Shopping button only');

  console.log('Cart drawer debug tool ready');
});
